import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { signOut, signUserOut } from '../../common/auth/actions'
import { inviteUsers } from '../../common/users/actions'
import { roles } from '../../common/config'
import { Button, TextInput, FacebookShare } from '../components'

class SignOutPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      inviteEmails: [''],
      submittedInvitations: false,
    }
  }

  componentDidMount() {
    const { signOut, viewer, signUserOut } = this.props
    if (viewer) {
      signUserOut(viewer.id)
    }
    signOut()
  }

  editEmail(e, index) {
    const newEmails = this.state.inviteEmails.map((email, id) => {
      if (index === id) {
        return e.target.value
      }
      return email
    })

    this.setState({ inviteEmails: newEmails })
  }

  addEmail() {
    this.setState({
      inviteEmails: [...this.state.inviteEmails, ''],
    })
  }

  submitInvite() {
    const { inviteEmails } = this.state
    const { inviteUsers, signedOutUser } = this.props

    inviteUsers(signedOutUser.id, inviteEmails)

    this.setState({
      inviteEmails: [''],
      submittedInvitations: true,
    })
  }

  render() {
    const { intl, signedOutUser } = this.props
    const { inviteEmails, submittedInvitations } = this.state

    return (
      <div className="sign-out flex-column">
        <p>{intl.formatMessage(messages.signedOut)}</p>
        {/* FB SHARE
        <div className="share-links">
          <FacebookShare />
        </div>
        */}

        {/* FEEDBACK */}
        {
          signedOutUser && signedOutUser.role === roles.TEACHER &&
          <div className="sign-out-feedback">
            <p>{intl.formatMessage(messages.feedback)}</p>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeyiOidcezrMgnHdtm9-Pgogcdn5bQivasx_fF6sY1vqW-9nQ/viewform">
              <Button positive>
                {intl.formatMessage(messages.fillFeedback)}
              </Button>
            </a>
          </div>
        }
        
        {/* INVITE */}
        {/*
          signedOutUser && signedOutUser.role === roles.TEACHER &&
          <div className="invite">
            <p>{intl.formatMessage(messages.inviteTeachers)}</p>
            {
              inviteEmails.map((email, index) => (
                <TextInput
                  key={index}
                  value={email}
                  onChange={(e) => this.editEmail(e, index)}
                  placeholder={intl.formatMessage(messages.emailPlaceholder)}
                />
              ))
            }
            <Button onClick={() => this.addEmail()}>
              {intl.formatMessage(messages.addEmail)}
            </Button>
            <Button
              big
              positive
              className="spacing-top"
              onClick={() => this.submitInvite()}
            >
              {intl.formatMessage(messages.submitInvite)}
            </Button>
          </div>
        */}
        {
          submittedInvitations &&
          <div className="invite-thanks">
            <p>{intl.formatMessage(messages.inviteThanks)}</p>
          </div>
        }
      </div>
    )
  }
}

SignOutPage.defaultProps = {
  viewer: null,
  signedOutUser: null,
}

SignOutPage.propTypes = {
  viewer: PropTypes.object,
  signedOutUser: PropTypes.object,
  signOut: PropTypes.func.isRequired,
  signUserOut: PropTypes.func.isRequired,
  inviteUsers: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    signedOutUser: state.users.signedOutUser,
  }), { signOut, inviteUsers, signUserOut }),
  injectIntl,
)

export default enhance(SignOutPage)

const messages = defineMessages({
  signedOut: {
    id: 'signOut.page.signedOut',
    defaultMessage: 'Dovidenia, boli ste odhlásený/á.',
  },
  inviteTeachers: {
    id: 'signOut.page.inviteTeachers',
    defaultMessage: 'Pozvite Vašich kolegov a zdielajte medzi sebou cvičenia.',
  },
  inviteThanks: {
    id: 'signOut.page.inviteThanks',
    defaultMessage: 'Ďakujeme.',
  },
  emailPlaceholder: {
    id: 'signOut.page.emailPlaceholder',
    defaultMessage: 'Zadajte email známeho',
  },
  addEmail: {
    id: 'signOut.page.addEmail',
    defaultMessage: 'Pridať ďalší email',
  },
  submitInvite: {
    id: 'signOut.page.submitInvite',
    defaultMessage: 'Pozvať',
  },
  feedback: {
    id: 'signOut.page.feedback',
    defaultMessage: 'Je pre Vás Vobo užitočné? Vyplňte prosím kratky formulár so spätnou väzbou na našu aplikáciu aby sme ju mohli zlepšiť',
  },
  fillFeedback: {
    id: 'signOut.page.fillFeedback',
    defaultMessage: 'Vyplniť spätnú väzbu',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/SignOutPage.js